import { useQuery } from "@tanstack/react-query";
import { getAssignedHardware } from "../../../resource/bff";

export const useGetAssignedHardwareAsync = () => {
  const { isLoading, error, data, isFetching } = useQuery(
    ["userAssets"],
    () => getAssignedHardware().then((res) => res),
    { cacheTime: Infinity }
  );
  return {
    isLoading,
    error,
    data,
    isFetching,
  };
};
